export default __webpack_public_path__ + "static/media/combot-grey-no-horn.68fcbe7d.svg";